module.exports = __webpack_public_path__ + "img/1311983229.35a4a336.jpg";